import type { SubscriptionStatus } from '@provalia/shared';
import { Badge } from '../../shared/ui';
import { SUBSCRIPTION_LABELS, SUBSCRIPTION_TONES } from '../labels';

export function SubscriptionBadge({ status }: { status: SubscriptionStatus }): JSX.Element {
  return <Badge tone={SUBSCRIPTION_TONES[status]}>{SUBSCRIPTION_LABELS[status]}</Badge>;
}

export function ActiveBadge({ active, on = 'Activo', off = 'Inactivo' }: { active: boolean; on?: string; off?: string }): JSX.Element {
  return <Badge tone={active ? 'ok' : 'neutral'}>{active ? on : off}</Badge>;
}
